export default {
  component: () => import('./page.vue'),
  path: '/:pathMatch(.*)*',
  name: 'error-404',
  meta: {
    title: '页面不存在',
  },
};
